import { Injectable } from '@angular/core';
import { SessionStore } from './session.store';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { User } from '@microsoft/microsoft-graph-types';

@Injectable({
  providedIn: 'root',
})
export class SessionRepository {
  constructor(private sessionStore: SessionStore, private http: HttpClient) {}

  updateUserName(name?: string) {
    this.sessionStore.update((s: { user: any }) => ({
      user: { ...s.user, name },
    }));
  }

  updateEmail(email?: string) {
    this.sessionStore.update((s: { user: any }) => ({
      user: { ...s.user, email },
    }));
  }

  loadGraphUser = async () => {
    const graphUser = await firstValueFrom(this.http.get<User>('https://graph.microsoft.com/v1.0/me'));
    this.sessionStore.update((s: { user: any }) => ({
      user: {
        ...s.user,
        email: graphUser.userPrincipalName,
        givenName: graphUser.givenName,
        surName: graphUser.surname,
        jobTitle: graphUser.jobTitle,
      },
    }));
  };
}
